import { Component, effect, inject, input, OnInit, signal } from '@angular/core';
import { MatListModule } from '@angular/material/list';
import { MatFormFieldModule } from '@angular/material/form-field';
import { TreatmentPlanItem, TreatmentPlansRepositoryService, ReportControl } from '@xmedical/core';
import { ReportControlEditorService } from '../../services/report-control-editor.service';

/**
 * TreatmentPlanListRendererComponent
 *
 * Renders a list of patient treatment plan items in a report.
 * Uses a refreshTrigger input signal instead of PatientEventsService.
 * The consuming app should increment refreshTrigger when treatment plans change.
 */
@Component({
  selector: 'xmed-treatment-plan-list-renderer',
  standalone: true,
  imports: [
    MatListModule,
    MatFormFieldModule
  ],
  templateUrl: './treatment-plan-list-renderer.component.html',
  styleUrl: './treatment-plan-list-renderer.component.scss'
})
export class TreatmentPlanListRendererComponent implements OnInit {
  private plansRepository = inject(TreatmentPlansRepositoryService);
  private editorService = inject(ReportControlEditorService);

  patientId = input.required<number>();
  control = input.required<ReportControl>();
  refreshTrigger = input<number>(0);

  actionList = signal<TreatmentPlanItem[]>([]);

  // Effect to reload when refreshTrigger changes
  private refreshEffect = effect(() => {
    const trigger = this.refreshTrigger();
    const pid = this.patientId();
    if (trigger > 0 && pid) {
      this.loadTreatmentPlans();
    }
  });

  ngOnInit(): void {
    this.actionList.set(this.control().treatmentPlanListValue || []);
    this.loadTreatmentPlans();
  }

  private loadTreatmentPlans(): void {
    this.plansRepository.loadPatientTreatmentPlanItems(this.patientId()).subscribe(actions => {
      const sorted = actions.sort((a, b) => a.createdDate > b.createdDate ? 1 : -1);
      this.actionList.set(sorted);
      this.control().treatmentPlanListValue = sorted;
      this.editorService.triggerEvent();
    });
  }
}
